up.compiler(
  '[data-track-click]',
  (element: HTMLElement, { alsoTrackAs }: { alsoTrackAs?: object }) => {
    up.on(element, 'up:click', () => {
      up.emit(element, 'analytics:track-click')
      if (alsoTrackAs) {
        up.emit(element, 'analytics:track-click', { eventData: alsoTrackAs } as any)
      }
    })
  },
)
